import '../sass/general-enquiries-form.scss';

(() => {
    const pristineScript = document.querySelector('#blenheim-schools-pristine-js');
    const $blocks = document.querySelectorAll('.block.general-enquiries-form');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $formErrors = $block.querySelector('.general-enquiries-form__form-errors');
        const $form = $block.querySelector('.general-enquiries-form__form');
        const $turnstile = $block.querySelector('.general-enquiries-form__form-turnstile');
        const $turnstileToken = $block.querySelector('.general-enquiries-form__form-turnstile-token');

        let turnstileInstance;

        const checkIfTurnstileReady = resolve => {
            const interval = setInterval(() => {
                if (!$turnstileToken.value) return;

                resolve(interval);
                clearInterval(interval);
            }, 100);
        };

        const submitForm = () => {
            fetch('/wp-json/blenheim-schools/enquiry', {
                method: 'POST',
                body: new FormData($form)
            }).then(async response => {
                const json = await response.json();

                return json;
            }).then(json => {
                if (json.errors) {
                    throw new Error(json.errors.join('<br />'));
                }

                if (json.success) {
                    const { successPage } = $form.dataset;

                    if (successPage) {
                        window.location.href = successPage;
                    }
                }
            }).catch(error => {
                if (error.message) {
                    $formErrors.innerHTML = error.message;
                    $formErrors.classList.add('general-enquiries-form__form-errors--show');
                }
            }).finally(() => {
                $form.classList.remove('general-enquiries-form__form--loading');

                turnstile.reset(turnstileInstance);
            });
        }

        const initForm = () => {
            if (!$form) return;

            const pristine = new Pristine($form);
            
            $form.addEventListener('submit', e => {
                e.preventDefault();

                $form.classList.add('general-enquiries-form__form--loading');
                $formErrors.classList.remove('general-enquiries-form__form-errors--show');

                if (!pristine.validate()) {
                    $form.classList.remove('general-enquiries-form__form--loading');

                    return;
                }

                if ($turnstile) {
                    const waitUntilReady = new Promise(checkIfTurnstileReady);

                    waitUntilReady.then(() => {
                        if (!pristine.validate()) {
                            $form.classList.remove('general-enquiries-form__form--loading');

                            return;
                        }
                        
                        submitForm();
                    });
                } else {
                    submitForm();
                }
            });
        };

        window.onloadTurnstileCallback = () => {
            if (!$turnstile) return;

            turnstileInstance = turnstile.render($turnstile, {
                sitekey: $turnstile?.dataset?.sitekey,
                callback: id => {
                    $turnstileToken.value = id;
                }
            });
        };

        if (typeof Pristine !== 'undefined') {
            initForm();
        } else if (pristineScript) {
            pristineScript.addEventListener('load', () => {
                initForm();
            });
        } else {
            window.addEventListener('load', () => {
                const pristineScript = document.querySelector('#blenheim-schools-pristine-js');

                if (!pristineScript) return;

                initForm();
            });
        }
    });
})();
